import { Grid } from '@mui/material'
import React from 'react'

function Footer() {
  return (
    <Grid pb={3} pt={2} sx={{textAlign:"center", background:"#DD952B", color:"white"}}>Copyright © 2000-2001 Ayura Mouthcare Kit All Rights Reserved.</Grid>
  )
}

export default Footer